import React from 'react';
import { Box } from '@mui/material';
import Body from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Body';
import { useTranslation } from 'react-i18next';
import { Controller, UseFormReturn } from 'react-hook-form';
import { UpdateArrearsForm } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/flyout/ArrearsFlyoutContent';
import { RadioField } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/RadioField';
import { RadioFieldOption } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/RadioField';
import { ArrearsStatus } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';

export const ArrearsFlyoutStatusField = ({
  isReadOnly = true,
  form
}: {
  isReadOnly: boolean;
  form: UseFormReturn<UpdateArrearsForm>;
}) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');

  const resetForm = (value: string) => {
    if (value === 'active') {
      form.trigger();
    } else {
      form.reset({
        ...form.formState.defaultValues,
        status: value as ArrearsStatus
      });
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap="8px">
      <Body size={'smallBold'}>{t('arrearsFlyout.status')}</Body>
      <Controller
        name="status"
        control={form.control}
        render={({ field }) => (
          <RadioField
            name={field.name}
            value={field.value}
            onBlur={field.onBlur}
            onChange={(event, value) => {
              resetForm(value);
              field.onChange(event, value);
            }}
          >
            <RadioFieldOption
              label={t('arrears.status.active')}
              value="active"
              disabled={isReadOnly}
            />
            <RadioFieldOption
              label={t('arrears.status.inactive')}
              value="inactive"
              disabled={isReadOnly}
            />
          </RadioField>
        )}
      />
    </Box>
  );
};
